function addLoginParams(url = '') {
  const token = sessionStorage.tokenParams;
  if (url.indexOf('?') >= 0) {
    url = `${url}&${token.replace('?', '')}`;
  } else {
    url = url + token;
  }
  return url;
}
export default addLoginParams;
